/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Meta_Ogdescription1Inputs */

const ja_work_meta_ogdescription1 = /** @type {(inputs: Work_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイブレーン(PLAYBRAIN)の制作実績について紹介します。マーケティング、eスポーツイベントの制作と運営、プロダクト開発の分野で多数の実績があります。`)
};

const en_work_meta_ogdescription1 = /** @type {(inputs: Work_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let me introduce PLAYBRAIN's portfolio. We have numerous achievements in marketing, esports event production and management, and product development.`)
};

/**
* | output |
* | --- |
* | "Let me introduce PLAYBRAIN's portfolio. We have numerous achievements in marketing, esports event production and management, and product development." |
*
* @param {Work_Meta_Ogdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const work_meta_ogdescription1 = /** @type {((inputs?: Work_Meta_Ogdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Meta_Ogdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_meta_ogdescription1(inputs)
	return en_work_meta_ogdescription1(inputs)
});
export { work_meta_ogdescription1 as "work_meta_ogDescription" }